






import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { EnumMDFactory } from '@/libs/com/MetaPattern/MDA/MD/EnumMDFactory';

@Component({
  components: {}
})
export default class PGRowEnumValue extends Vue {
  @Prop() private value!: string;
  @Prop() private refType!: string;
  @Prop() private isEditable!: boolean;
  private textValue!: string;

  constructor() {
    super();
    this.textValue = this.value;
  }

  saveChange(): void {
    this.$emit('valueChanged', this.textValue);
  }

  get options() {
    const enumMDs = EnumMDFactory.getEnumMD(this.refType);
    if (enumMDs != null) return enumMDs;
    return null;
  }

  @Watch('value')
  refresh() {
    this.textValue = this.value;
  }
}
